import moment from 'moment'
import STATICS from '../event.statics'

const formatDate = (date, format) =>
  moment(date, 'YYYY-MM-DD').isValid()
    ? moment(date, 'YYYY-MM-DD').format(format)
    : 'TBD'

const formatAuctionDateTime = (
  auctionStartDateTime,
  auctionEndDateTime,
  isStart
) => {
  const now = moment()
  const auctionStartMoment = auctionStartDateTime
  const auctionEndMoment = auctionEndDateTime

  if (!auctionStartMoment.isValid() || !auctionEndMoment.isValid()) {
    return ''
  } else if (auctionEndMoment.diff(now) < 0) {
    return STATICS.BIDDING_ENDED
  } else if (auctionStartMoment.diff(now) < 0 && isStart) {
    return STATICS.BIDDING_STARTED
  } else {
    return isStart
      ? auctionStartMoment.format('MMM DD, YYYY, hh:mm A')
      : auctionEndMoment.format('MMM DD, YYYY, hh:mm A')
  }
}

export { formatDate, formatAuctionDateTime }
